import firebase from 'firebase/app'

require("firebase/auth");
require("firebase/database");
require("firebase/storage");

firebase.initializeApp({
  "apiKey": process.env.REACT_APP_FIREBASE_SHOWROOM_APIKEY,
  "authDomain": process.env.REACT_APP_FIREBASE_SHOWROOM_AUTHDOMAIN,
  "databaseURL": process.env.REACT_APP_FIREBASE_SHOWROOM_DATABASEURL,
  "projectId": process.env.REACT_APP_FIREBASE_SHOWROOM_PROJECTID,
  "storageBucket": process.env.REACT_APP_FIREBASE_SHOWROOM_STORAGEBUCKET,
  "messagingSenderId": process.env.REACT_APP_FIREBASE_SHOWROOM_MESSAGINGSENDERID,
});

export const auth = firebase.auth();
export const database = firebase.database();
export const storage = firebase.storage();

/* authenticate app */
export async function authenticateApp() {
	const email = 'showroom@sensotix.com';
	const password = 'showroom$93Dnya';

	if (auth.currentUser) await auth.signOut();

	auth.signInWithEmailAndPassword(email, password).then(() => {
    console.log('Logged in with uid ' + auth.currentUser.uid);
  })
}

/* export functions */

// get statistics from feedback, questions 1
export function onUpdateNews(cb) {
	database.ref("/news").on('value', cb);
}


// WEBPACK FOOTER //
// ./src/db/firebase/admin.js